import { useQuery } from '@apollo/client';
import { GET_PICKUP_ROUTES_WITH_VEHICLE_INFO } from '../graphql/queries/getPickupRoutes';
import { PickupRouteWithVehicleInfoType } from '../graphql/types/PickupRouteTypes';

export const usePickupRoutesWithDetails = (warehouseId: string | null, pickupDate: string) => {
  const { data, loading, error, refetch } = useQuery(GET_PICKUP_ROUTES_WITH_VEHICLE_INFO, {
    variables: { 
      warehouseId: warehouseId ? parseInt(warehouseId) : undefined,
      pickupDate: pickupDate
    },
    skip: !warehouseId || !pickupDate,
    fetchPolicy: 'cache-and-network',
  });

  const routes: PickupRouteWithVehicleInfoType[] = data?.getPickupRoutesWithVehicleInfoByWarehouseId || [];

  return {
    routes,
    loading,
    error,
    refetch
  };
};
